import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "uk-flex uk-flex-center uk-flex-row uk-flex-wrap" }
const _hoisted_2 = { class: "uk-width-1-2 uk-text-left uk-flex uk-flex-column" }
const _hoisted_3 = { class: "uk-width-1-2 uk-text-left uk-flex uk-flex-column" }
const _hoisted_4 = { class: "uk-width-1-1 uk-flex-inline uk-flex-column uk-text-left" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = {
  key: 1,
  class: "uk-form-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputField = _resolveComponent("InputField")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
        class: "uk-margin uk-form uk-grid",
        "uk-grid": ""
      }, [
        _createElementVNode("div", _hoisted_2, [
          _cache[4] || (_cache[4] = _createElementVNode("label", {
            for: "carrierName",
            class: "uk-form-label"
          }, "Carrier Name", -1)),
          _createVNode(_component_InputField, {
            id: "carrierName",
            modelValue: _ctx.carrierName,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.carrierName) = $event)),
            class: _normalizeClass({ 'uk-form-danger': _ctx.textDanger })
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[5] || (_cache[5] = _createElementVNode("label", {
            for: "carrierName",
            class: "uk-form-label"
          }, "Carrier Email", -1)),
          _createVNode(_component_InputField, {
            id: "carrierEmail",
            modelValue: _ctx.carrierEmail,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.carrierEmail) = $event)),
            class: _normalizeClass({ 'uk-form-danger': _ctx.textDanger })
          }, null, 8, ["modelValue", "class"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[7] || (_cache[7] = _createElementVNode("label", { class: "uk-form-label" }, _toDisplayString('\xa0'), -1)),
          _createElementVNode("button", {
            class: "uk-button uk-button-primary uk-form-controls",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.addNewCarrier && _ctx.addNewCarrier(...args)))
          }, [...(_cache[6] || (_cache[6] = [
            _createElementVNode("div", { "uk-icon": "icon: plus" }, null, -1),
            _createTextVNode(" Add New Carrier ", -1)
          ]))])
        ])
      ], 32)
    ]),
    (_ctx.loadingLoad)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[8] || (_cache[8] = [
          _createElementVNode("div", {
            class: "uk-alert-primary",
            "uk-alert": ""
          }, [
            _createElementVNode("div", { "uk-spinner": "" })
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.loadFormError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("p", null, _toDisplayString(_ctx.loadFormError), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}